module.exports = __webpack_public_path__ + "static/media/Information Guidance For Customers in Revit.c90ba935.png";